import {atom} from "jotai";
import {WebAppMainApi$UiContext} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

type ContextOrFalse = WebAppMainApi$UiContext | false

export const uiContextState = atom<ContextOrFalse>(false)

